const localeObj = process.env.NEXT_PUBLIC_RINUS_LOCALES?.split(',')
const namespaceObj = process.env.NEXT_PUBLIC_RINUS_NAMESPACES?.split(',')
const theme = process.env.NEXT_PUBLIC_THEME
module.exports = {
  i18n: {
    defaultLocale: process.env.NEXT_PUBLIC_RINUS_DEFAULT_LANGUAGE,
    locales: localeObj || process.env.NEXT_PUBLIC_RINUS_DEFAULT_LANGUAGE,
    localeDetection: false
  },
  defaultNS: [...(namespaceObj ? [namespaceObj, theme] : [theme, 'football'])],
  fallbackNS: ['football', 'common'],
  ns: namespaceObj,
  serializeConfig: false
}
